import React, { useEffect, useState } from "react";
import { Theme } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import { useDebounce } from "use-debounce";
import { SearchField } from "@rentablo/components";

type Props = {
  id: string;
  placeholder?: string;
  value: string;
  onDebouncedChange: (value: string) => void;
  sx?: SxProps<Theme>;
  size?: "small" | "medium";
};

export const DebouncedSearch = React.memo(
  ({ id, placeholder, value, onDebouncedChange, sx, size }: Props) => {
    const [typingValue, setTypingValue] = useState(value);
    const [prevValue, setPrevValue] = useState(value);
    if (prevValue !== value) {
      setPrevValue(value);
      setTypingValue(value);
    }
    const [debouncedValue] = useDebounce(typingValue, 300);

    useEffect(() => {
      onDebouncedChange(debouncedValue);
    }, [debouncedValue, onDebouncedChange]);

    return (
      <SearchField
        id={id}
        placeholder={placeholder}
        value={typingValue}
        onChange={(e) => setTypingValue(e.target.value)}
        sx={sx}
        size={size}
      />
    );
  }
);
DebouncedSearch.displayName = "DebouncedSearch";
